import React, { useState } from "react"
import { auth } from "../firebaseClient"
import { sendEmailVerification } from "firebase/auth"
import Button from "./ui/Button"
import Icon from "./AppIcon"

// Blocks access to children until the current user's email is verified.
// Firebase caches emailVerified on the token, so we reload the user object
// to check the latest status when the person clicks the confirm button.
const EmailVerificationGate = ({ children }) => {
  const [checking, setChecking] = useState(false)
  const [resent, setResent] = useState(false)
  const [isVerified, setIsVerified] = useState(auth.currentUser?.emailVerified || false)
  const [error, setError] = useState("")

  const handleResend = async () => {
    setError("")
    setResent(false)
    try {
      await sendEmailVerification(auth.currentUser)
      setResent(true)
    } catch (err) {
      setError(err?.message || "Could not resend verification email.")
    }
  }

  const handleCheckVerified = async () => {
    setChecking(true)
    setError("")
    try {
      await auth.currentUser?.reload()
      setIsVerified(auth.currentUser?.emailVerified || false)
    } catch (err) {
      setError(err?.message || "Could not check verification status.")
    }
    setChecking(false)
  }

  if (isVerified) {
    return children
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-card border border-border rounded-xl p-8 text-center">
        <div className="w-14 h-14 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="MailCheck" size={24} className="text-accent" />
        </div>
        <h2 className="text-xl font-bold text-foreground mb-2">Verify your email</h2>
        <p className="text-muted-foreground text-sm mb-6">
          We sent a verification link to{" "}
          <span className="font-medium text-foreground">{auth.currentUser?.email}</span>.
          Click the link, then come back and press the button below.
        </p>

        {error && <p className="text-sm text-destructive mb-4">{error}</p>}
        {resent && <p className="text-sm text-success mb-4">Verification email resent.</p>}

        <div className="space-y-2">
          <Button variant="default" fullWidth loading={checking} onClick={handleCheckVerified}>
            I've verified my email
          </Button>
          <Button variant="ghost" fullWidth onClick={handleResend}>
            Resend verification email
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EmailVerificationGate